<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="14.734" height="14.306" viewBox="0 0 14.734 14.306">
        <g transform="translate(-356.802 -113.717)">
            <g transform="translate(367.116 113.717)">
                <path class="a" :fill="this.$vuetify.theme.dark ? '#CECECE' : '#383935'" d="M481.73,116.652a.514.514,0,0,0,.514-.514v-1.907a.514.514,0,1,0-1.028,0v1.907A.514.514,0,0,0,481.73,116.652Z" transform="translate(-481.216 -113.717)"/>
            </g>
            <g transform="translate(356.802 114.688)">
                <path class="a" :fill="this.$vuetify.theme.dark ? '#CECECE' : '#383935'" d="M369.583,125.429h-1.028v1.028h1.028a.989.989,0,0,1,.925,1.041v1.071H357.83V127.5a.989.989,0,0,1,.925-1.041h1.028v-1.028h-1.028A2.016,2.016,0,0,0,356.8,127.5v9.2a2.016,2.016,0,0,0,1.953,2.068h10.828a2.016,2.016,0,0,0,1.953-2.068v-9.2A2.016,2.016,0,0,0,369.583,125.429Zm0,12.307H358.755a.989.989,0,0,1-.925-1.04v-7.1h12.678v7.1A.989.989,0,0,1,369.583,137.736Z" transform="translate(-356.802 -125.429)"/>
            </g>	
            <g transform="translate(361.633 114.688)">
                <rect class="a" :fill="this.$vuetify.theme.dark ? '#CECECE' : '#383935'" width="5.071" height="1.028" transform="translate(0 0)"/>
            </g>
            <g transform="translate(360.194 113.717)">
                <path class="a" :fill="this.$vuetify.theme.dark ? '#CECECE' : '#383935'" d="M398.235,116.652a.514.514,0,0,0,.514-.514v-1.907a.514.514,0,1,0-1.028,0v1.907A.514.514,0,0,0,398.235,116.652Z" transform="translate(-397.721 -113.717)"/>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
  name: 'CalendarIcon'
}
</script>

<style scoped>
    svg {
        width:14.734px;
        height:14.306px;
    }
</style>